import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { DateTime } from 'luxon';
import {
  API,
  AtomTypeDTO,
  ComparisonOperator,
  CullAtomDTO,
  CullWithAtomsDTO,
  DisplayableValueDTO,
  FieldReference,
  FreeTextFieldReference,
  NamedIdentityDTO,
  RangeFieldReference,
  SelectionFieldReference,
  Serializable,
} from 'src/app/services/api/api';
import { SbDateTime, SbLocalDateTime, SbLocalTime } from 'src/app/services/api/api-date-time';
import { DatePickResult, FreetextResult, SearchSelectResult, SelectResult, SelectValue } from 'src/app/services/gui/modal/modal.model';
import { ModalService } from 'src/app/services/gui/modal/modal.service';
import { KeyValue } from '@angular/common';
import { UtilService } from 'src/app/services/util.service';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorService } from 'src/app/services/error.service';
import { StringTransformationService } from '../../../services/transformation-helper/string-transformation.service';

@Component({
  selector: 'sb-filter-definition-row',
  templateUrl: './sb-filter-definition-row.component.html',
  styleUrls: ['./sb-filter-definition-row.component.scss'],
  standalone: false,
})
export class SbFilterDefinitionRowComponent implements OnInit {
  private readonly stringTransformation = inject(StringTransformationService);

  @Output() changesEmitter: EventEmitter<string> = new EventEmitter<string>();

  @Input() leftOperators: string[] = [];
  @Input() rightOperators: string[] = [];
  @Input() atom: CullAtomDTO;
  @Input() inDeleteProcess: boolean = false;
  @Input() rowIndex: number;

  @Output() leftOperatorsChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() rightOperatorsChange: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() atomChange: EventEmitter<CullAtomDTO> = new EventEmitter<CullAtomDTO>();

  @Output() deleteClick: EventEmitter<any> = new EventEmitter<any>();

  @Input() disabled: boolean = false;
  die: boolean = false;

  removeOperatorOptions: string[] = ['not equal', 'less than', 'less or equal', 'greater than', 'not in', 'is empty', 'is not empty'];
  atomTypeText: string;
  referenceText = new Map<unknown, unknown>();
  fieldText = new Map<unknown, unknown>();

  private set _leftoperators(val: string[]) {
    this.leftOperators = val;
    this.leftOperatorsChange.emit(this.leftOperators);
    if (!this.inDeleteProcess) {
      this.changesEmitter.emit();
    }
  }

  private get _leftoperators(): string[] {
    return this.leftOperators;
  }

  private set _rightoperators(val: string[]) {
    this.rightOperators = val;
    this.rightOperatorsChange.emit(this.rightOperators);
    if (!this.inDeleteProcess) {
      this.changesEmitter.emit();
    }
  }

  private get _rightoperators(): string[] {
    return this.rightOperators;
  }

  private set _atom(val: CullAtomDTO) {
    this.atom = val;
    this.atomChange.emit(this.atom);
    if (!this.inDeleteProcess) {
      this.changesEmitter.emit();
    }
  }

  private get _atom(): CullAtomDTO {
    return this.atom;
  }

  @Input() type: string;
  // tslint:disable-next-line:variable-name
  _cull: CullWithAtomsDTO;
  @Input() set cull(val: CullWithAtomsDTO) {
    this._cull = val;
    this.refreshFromSetter();
  }

  get cull() {
    return this._cull;
  }

  // tslint:disable-next-line:variable-name
  private _setup: any[] = null;
  @Input() set setup(val: any[]) {
    this._setup = val;
    this.refreshFromSetter();
  }

  get setup(): any[] {
    return this._setup;
  }

  // tslint:disable-next-line:variable-name
  private _singleSetup: any = null;
  @Input() set singleSetup(val: any) {
    this._singleSetup = val;
    if (val) {
      this.references = val;
      if (this.atom) {
        this.atom['_setup'] = val;
      }
    }
  }

  get singleSetup(): any {
    return this._singleSetup;
  }

  // tslint:disable-next-line:variable-name
  _atomTypes: Map<string, AtomTypeDTO>;
  @Input() set atomTypes(atomTypes: Map<string, AtomTypeDTO>) {
    this._atomTypes = atomTypes;
  }

  get atomTypes(): Map<string, AtomTypeDTO> {
    return this._atomTypes;
  }

  // tslint:disable-next-line:variable-name
  _references: any;
  get references(): any {
    return this._references;
  }

  set references(val: any) {
    this._references = val;
    this.initTextFields();
  }

  valueAscOrder = (a: KeyValue<any, any>, b: KeyValue<any, any>): number => {
    // if (a && b && a.value && b.value && a.value.order && b.value.order ) {// order ist eine Zahl!!! Eine Zahl 0 gibt FALSE zurueck!!!!!!!
    if (a && b && a.value && b.value && a.value.order != null && b.value.order != null) {
      if (a.value.order < b.value.order) {
        return -1;
      }
      if (a.value.order > b.value.order) {
        return 1;
      }
    }
    return 0;
  };

  atomType(type: string): AtomTypeDTO {
    return this._atomTypes.get(type);
  }

  refreshFromSetter() {
    /*
     if (this.cull) {
       if (this.cull.atoms) {
         // for (let a of this.cull.atoms) {
         //   if (a.id.num === +this.atom.id.num) {
         //     this.myatom = a;
         //     break;
         //   }
         // }
         if (this._setup) {
           for (let a of this._setup) {
             if (a.atom.id.num === +this.atom.id.num) {
               this.references = a.setup;
               break;
             }
           }
         }
       }
     }
     */
    this.references = this.atom['_setup'];
  }

  constructor(
    private api: API,
    private modal: ModalService,
    private util: UtilService,
    public translate: TranslateService,
    private errorHandler: ErrorService,
    private destroyRef: DestroyRef
  ) {
    this.inDeleteProcess = false;
  }

  onLeftOperatorSelected($event) {
    this.leftOperators.push($event);
    this._leftoperators = this.leftOperators;
  }

  onRightOperatorSelected($event) {
    this.rightOperators.push($event);
    this._rightoperators = this.rightOperators;
  }

  ngOnInit() {
    this.atomTypeText = this.getAtomTypeText(this.atomType(this.atom.type).name);
    this.initTextFields();
  }

  initTextFields() {
    if (this._references) {
      const refs = Object.entries(this._references).map(([key, value]) => ({ key, value }));
      for (const ref of refs) {
        this.referenceText.set(ref.key, this.getReferenceKeyText(ref));
        this.getFieldText(ref).then(result => {
          this.fieldText.set(ref.key, result);
        });
      }
    }
  }

  refreshFilterSelections() {
    const atmn = Object.assign({}, this.atom);
    delete atmn.id;
    this.api
      .cs_Cull_atomSetupForCullAtom(atmn)
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: (e: any) => {
          this.singleSetup = e;
          if (!this.inDeleteProcess) {
            this.changesEmitter.emit();
          }
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
    this.initTextFields();
  }

  getFieldReference(field) {
    if (this.references) {
      return this.references[field];
    }
  }

  getField(field) {
    if (this.atom && field) {
      return this.atom[field];
    }

    return null;
  }

  getFieldDescriptor(reference) {
    if (this.atom && this.atom['_setup'] && reference) {
      return this.atom['_setup'][reference];
    }
    return null;
  }

  getFieldText(reference, val?) {
    return new Promise(resolve => {
      if (!val) {
        val = this.getField(reference.key);
      }

      const descriptor = this.getFieldDescriptor(reference.key);

      if (val != null) {
        if (descriptor && descriptor._type === 'SelectionFieldReference') {
          const selectionFieldReference: SelectionFieldReference = descriptor;
          if (selectionFieldReference.lookup) {
            let valArr = val;
            if (!Array.isArray(valArr)) {
              valArr = [valArr];
            }
            this.lookup(reference, selectionFieldReference.lookup, valArr).then(result => {
              resolve(result);
            });
          } else {
            const res = this.getFieldTextResolution(reference, val);
            resolve(res);
          }
        } else {
          const res = this.getFieldTextResolution(reference, val);
          resolve(res);
        }
      }
    });
  }

  private lookup(reference, lookup: string, valArr) {
    return new Promise(resolve => {
      this.api
        .cs_Cull_selectionLookup(lookup, this.atom, {
          lookup: valArr,
        })
        .subscribe((lookupResult: DisplayableValueDTO[]) => {
          const values: any[] = [];
          for (const res of lookupResult) {
            if (res.display instanceof NamedIdentityDTO) {
              values.push(res.display.name + '(' + res.display.id + ')');
            }
            if (typeof res.display === 'string') {
              values.push(res.display);
            }
          }
          const textResolution = this.getFieldTextResolution(reference, values);
          resolve(textResolution);
        });
    });
  }

  private getFieldTextResolution(reference, val) {
    if (val instanceof SbLocalTime) {
      return val.toHumanString();
    }

    if (val instanceof SbDateTime || val instanceof SbLocalDateTime) {
      return this.parseDate(val);
    }

    if (val instanceof NamedIdentityDTO) {
      return val.name;
    }

    if (reference.key === 'operator') {
      // descriptor?.type === 'ComparisonOperator') {
      return this.getOperatorText(val);
    }

    if (reference.key === 'part') {
      // descriptor?.type === 'DateTimePart') {
      if (val instanceof Array && val.length === 1) {
        return this.getPartOfTimeText(val[0]);
      }
      return this.getPartOfTimeText(val);
    }

    if (reference.key === 'partValue') {
      // (this.atom as unknown as any)?.part === 'DayOfWeek' && descriptor) {
      switch (true) {
        case reference?.value?.max > 1000:
          return val;
        case reference?.value?.max > 360:
          const firstDayOfYear = DateTime.local().startOf('year');
          return this.util.dateToDateString(firstDayOfYear.plus({ days: val - 1 }));
        case reference?.value?.max >= 28:
          return val;
        case reference?.value?.max === 7:
          return this.getWeekdayText(val);
        default:
          return val;
      }
    }

    if (val instanceof Array) {
      let ret: string = '';

      if (val.length > 0) {
        ret +=
          val[0] === ''
            ? this.translate.instant('lang.globals.empty')
            : val[0].toString().length > 25
              ? val[0].toString().substr(0, 25) + '...'
              : val[0];
        if (val.length > 1) {
          ret += ', ... ';
          ret += '(';
          ret += val.length - 1;
          ret += ' more)';
        }
      }

      return ret;
    }

    if (typeof val === 'string') {
      return val.length > 25 ? val.toString().substr(0, 25) + '...' : val;
    }
    return val;
  }

  showNewReferenceModal(ref: KeyValue<string, any>, atom: CullAtomDTO) {
    if (this.disabled) {
      return;
    }
    let values: SelectValue<Serializable>[];
    let initialValue: SelectValue<DisplayableValueDTO>;
    let message: string;
    let title: string;

    let tempValues: any[] = [];
    let tempInitialValue: any;

    let tempDisplayableValues: DisplayableValueDTO[];
    let tempDisplayInitialValue: DisplayableValueDTO;
    let lookup: string;

    let singlemode: boolean = false;

    let reference: FieldReference;

    const property = ref.key;
    reference = ref.value;

    if (reference) {
      title = this.translate.instant('lang.globals.selectNamedValueTitle', { name: property });
      message = this.translate.instant('lang.globals.selectNamedValueCaption', { name: property });
      switch (reference._type) {
        case 'FreeTextFieldReference':
          const freeTextFieldReference: FreeTextFieldReference = reference as FreeTextFieldReference;
          this.freetextModal(property, freeTextFieldReference.values, freeTextFieldReference.autocomplete);
          return;
        case 'SelectionFieldReference':
          singlemode = !reference.type?.includes('[]');
          const selectionFieldReference: SelectionFieldReference = reference as SelectionFieldReference;

          tempDisplayableValues = selectionFieldReference.values;
          lookup = selectionFieldReference.lookup;

          tempDisplayInitialValue = this.getField(property);

          values = [];
          initialValue = null;

          if (tempDisplayableValues && tempDisplayableValues.length) {
            for (const val of tempDisplayableValues) {
              values.push({ name: val.display as string, value: val.value });
            }
          }

          this.getFieldText(ref, tempDisplayInitialValue).then(res => {
            initialValue = tempDisplayInitialValue
              ? {
                  name: res.toString(),
                  value: tempDisplayInitialValue,
                }
              : null;
          });

          break;

        case 'RangeFieldReference':
          const rangeFieldReference: RangeFieldReference = reference as RangeFieldReference;

          if (rangeFieldReference.type === 'SbLocalDateTime') {
            rangeFieldReference.min = new SbLocalDateTime(DateTime.fromISO(rangeFieldReference.min));
            rangeFieldReference.max = new SbLocalDateTime(DateTime.fromISO(rangeFieldReference.max));
          } else if (rangeFieldReference.type === 'SbLocalTime') {
            rangeFieldReference.min = new SbLocalTime(DateTime.fromISO(rangeFieldReference.min));
            rangeFieldReference.max = new SbLocalTime(DateTime.fromISO(rangeFieldReference.max));
          }

          tempInitialValue = this.getField(property);
          if (rangeFieldReference.min instanceof SbLocalTime) {
            let initial: DatePickResult = null;
            const castTempInitialValue = tempInitialValue as SbLocalTime;

            if (tempInitialValue) {
              initial = {
                time: {
                  hour: castTempInitialValue.value.hour,
                  minute: castTempInitialValue.value.minute,
                  second: castTempInitialValue.value.second,
                },
                cancel: false,
              };
            }

            this.timeModal(initial, title, property);
            return;
          } else if (rangeFieldReference.min instanceof SbLocalDateTime || rangeFieldReference.min instanceof SbDateTime) {
            let initial: DatePickResult = null;
            const castTempInitialValue = tempInitialValue as SbDateTime | SbLocalDateTime;

            if (tempInitialValue) {
              initial = {
                date: {
                  year: castTempInitialValue.value.year,
                  month: castTempInitialValue.value.month,
                  day: castTempInitialValue.value.day,
                },
                time: {
                  hour: castTempInitialValue.value.hour,
                  minute: castTempInitialValue.value.minute,
                  second: castTempInitialValue.value.second,
                },
                cancel: false,
              };
            }

            this.localDateTimeModal(initial, title, property);
            return;
          } else {
            const min: number = +rangeFieldReference.min;
            const max: number = +rangeFieldReference.max;

            tempValues = [];

            for (let d = min; d <= max; d++) {
              tempValues.push(d);
            }

            values = [];

            for (const val of tempValues) {
              this.getFieldText(ref, val).then(res => {
                values.push({ name: res.toString(), value: val });
              });
            }
          }

          initialValue = null;
          this.getFieldText(ref, tempInitialValue).then(res => {
            initialValue = tempInitialValue
              ? {
                  name: res.toString(),
                  value: tempInitialValue,
                }
              : null;
          });

          break;

        default:
          return;
      }
    }
    // TODO fix when all operators are possible
    if (property === 'operator' && atom._type.substring(0, 6) === 'Player') {
      const filteredValues: SelectValue<Serializable>[] = [];
      for (const val of values) {
        if (!this.removeOperatorOptions.includes(val.name)) {
          filteredValues.push(val);
        }
      }
      values = filteredValues;
    }

    this.refModal(values, initialValue, message, title, property, lookup, singlemode);
  }

  refModal(pValues: any[], pInitialValue: any, pMessage: string, pTitle: string, pField: string, pLookup: string, pSingleMode?: boolean) {
    if (pLookup) {
      this.modal
        .searchSelect({
          cullAtomLookup: { cullAtom: this.atom, lookup: pLookup },
          title: pTitle,
          singlemode: pSingleMode,
          modalOptions: { size: 'xl' },
        })
        .then((result: SearchSelectResult<any>) => {
          if (!result.cancel) {
            if (pSingleMode) {
              this.atom[pField] = result.values[0]?.value ? result.values[0].value : null;
            } else {
              const arr = [];
              for (const res of result.values) {
                arr.push(res.value);
              }
              this.atom[pField] = arr;
            }

            this._atom = this.atom;
            this.refreshFilterSelections();
          }
        })
        .catch(() => {});
    } else {
      if (pField === 'operator') {
        for (const val of pValues) {
          val.name = this.translate.instant('lang.comparisonOperator.' + this.stringTransformation.toCamelCase(val.name));
        }
      }
      this.modal
        .select({
          values: pValues,
          initialValue: pInitialValue,
          yes: this.translate.instant('lang.globals.ok'),
          no: this.translate.instant('lang.globals.cancel'),
          message: pMessage,
          title: pTitle,
          modalOptions: { size: 'xl' },
        })
        .then((result: SelectResult<any>) => {
          if (!result.cancel) {
            this.atom[pField] = result.value.value;
            this._atom = this.atom;
            this.refreshFilterSelections();
          }
        })
        .catch(() => {});
    }
  }

  showDateTimeModal(initial, title, field, useDate: boolean, useTime: boolean): Promise<SelectResult<DatePickResult>> {
    return new Promise(resolve => {
      this.modal
        .datepicker(useDate, useTime, initial, title, { size: 'lg' })
        .then(res => {
          if (res.cancel) {
            resolve({
              cancel: true,
            });
          } else {
            resolve({
              value: {
                value: res,
                name: '',
              },
              cancel: false,
            });
          }
          resolve(res);
        })
        .catch(() => {
          resolve({
            cancel: true,
          });
        });
    });
  }

  dateTimeModal(initial, title, field) {
    this.showDateTimeModal(initial, title, field, true, true)
      .then((result: SelectResult<DatePickResult>) => {
        if (!result.cancel) {
          const val: DatePickResult = result.value.value;
          this.atom[field] = new SbDateTime(
            DateTime.utc(val.date.year, val.date.month, val.date.day, val.time.hour, val.time.minute, val.time.second, 0)
          );
          this._atom = this.atom;
          this.refreshFilterSelections();
        }
      })
      .catch(() => {});
  }

  dateModal(initial, title, field) {
    this.showDateTimeModal(initial, title, field, true, false)
      .then((result: SelectResult<DatePickResult>) => {
        if (!result.cancel) {
          const val: DatePickResult = result.value.value;
          this.atom[field] = new SbDateTime(
            DateTime.utc(val.date.year, val.date.month, val.date.day, val.time.hour, val.time.minute, val.time.second, 0)
          );
          this._atom = this.atom;
          this.refreshFilterSelections();
        }
      })
      .catch(() => {});
  }

  localDateTimeModal(initial, title, field) {
    this.showDateTimeModal(initial, title, field, true, true)
      .then((result: SelectResult<DatePickResult>) => {
        if (!result.cancel) {
          const val: DatePickResult = result.value.value;
          this.atom[field] = new SbLocalDateTime(
            DateTime.utc(val.date.year, val.date.month, val.date.day, val.time.hour, val.time.minute, val.time.second, 0)
          );
          this._atom = this.atom;
          this.refreshFilterSelections();
        }
      })
      .catch(() => {});
  }

  localDateModal(initial, title, field) {
    this.showDateTimeModal(initial, title, field, true, false)
      .then((result: SelectResult<DatePickResult>) => {
        if (!result.cancel) {
          const val: DatePickResult = result.value.value;
          this.atom[field] = new SbLocalDateTime(
            DateTime.utc(val.date.year, val.date.month, val.date.day, val.time.hour, val.time.minute, val.time.second, 0)
          );
          this._atom = this.atom;
          this.refreshFilterSelections();
        }
      })
      .catch(() => {});
  }

  timeModal(initial, title, field) {
    this.showDateTimeModal(initial, title, field, false, true)
      .then((result: SelectResult<DatePickResult>) => {
        if (!result.cancel) {
          const val: DatePickResult = result.value.value;
          this.atom[field] = new SbLocalTime({ hour: val.time.hour, minute: val.time.minute, second: val.time.second });
          this._atom = this.atom;
          this.refreshFilterSelections();
        }
      })
      .catch(() => {});
  }

  freetextModal(pField, pValues: any[], pAutocomplete: string) {
    this.modal
      .multiFreetextFiltered({
        title: '',
        initial: this.atom[pField],
        values: pValues,
        cullAtomAutoComplete: { cullAtom: this.atom, autocomplete: pAutocomplete },
        modalOptions: { size: 'lg' },
      })
      .then((res: FreetextResult<any>) => {
        if (res && !res.cancel) {
          this.atom[pField] = res.value;
          this._atom = this.atom;
          this.refreshFilterSelections();
        }
      })
      .catch(() => {});
  }

  parseDate(date: SbDateTime | SbLocalDateTime) {
    try {
      return date.value.toFormat('dd.MM.yyyy HH:mm:ss');
    } catch {
      return 'UNDEFINED';
    }
  }

  getWeekdayText(part) {
    switch (+part) {
      case 1:
        return this.translate.instant('lang.globals.weekday.monday');
      case 2:
        return this.translate.instant('lang.globals.weekday.tuesday');
      case 3:
        return this.translate.instant('lang.globals.weekday.wednesday');
      case 4:
        return this.translate.instant('lang.globals.weekday.thursday');
      case 5:
        return this.translate.instant('lang.globals.weekday.friday');
      case 6:
        return this.translate.instant('lang.globals.weekday.saturday');
      case 7:
        return this.translate.instant('lang.globals.weekday.sunday');
    }

    return '!FIXME! ' + part + ' !FIXME!';
  }

  getPartOfTimeText(filter: string) {
    switch (filter) {
      case 'DayOfMonth':
        return this.translate.instant('lang.globals.dayOfMonth');
      case 'DayOfWeek':
        return this.translate.instant('lang.globals.dayOfWeek');
      case 'DayOfYear':
        return this.translate.instant('lang.globals.dayOfYear');
      case 'Hour':
        return this.translate.instant('lang.globals.hour');
      case 'Minute':
        return this.translate.instant('lang.globals.minute');
      case 'Month':
        return this.translate.instant('lang.globals.month');
      case 'WeekOfMonth':
        return this.translate.instant('lang.globals.weekOfMonth');
      case 'WeekOfYear':
        return this.translate.instant('lang.globals.weekOfYear');
      case 'Year':
        return this.translate.instant('lang.globals.year');
    }

    return '!FIXME! ' + filter + ' !FIXME!';
  }

  getOperatorText(operator: string) {
    if (this.atom) {
      return this.translate.instant('lang.comparisonOperator.' + operator.charAt(0).toLowerCase() + operator.substring(1));
    }
  }

  operatorByString(val): ComparisonOperator {
    switch (val) {
      case 'Equal':
        return ComparisonOperator.Equal;
      case 'NotEqual':
        return ComparisonOperator.NotEqual;
      case 'LessThan':
        return ComparisonOperator.LessThan;
      case 'LessOrEqual':
        return ComparisonOperator.LessOrEqual;
      case 'GreaterThan':
        return ComparisonOperator.GreaterThan;
      case 'GreaterOrEqual':
        return ComparisonOperator.GreaterOrEqual;
      case 'Like':
        return ComparisonOperator.Like;
      case 'NotLike':
        return ComparisonOperator.NotLike;
      case 'In':
        return ComparisonOperator.In;
      case 'NotIn':
        return ComparisonOperator.NotIn;
      case 'IsNull':
        return ComparisonOperator.IsNull;
      case 'IsNotNull':
        return ComparisonOperator.IsNotNull;
    }

    return null;
  }

  getDefText(part, partname) {
    if (this.atom) {
      switch (partname) {
        case 'DayOfWeek':
          switch (+part) {
            case 1:
              return 'Monday';
            case 2:
              return 'Tuesday';
            case 3:
              return 'Wednesday';
            case 4:
              return 'Thursday';
            case 5:
              return 'Friday';
            case 6:
              return 'Saturday';
            case 7:
              return 'Sunday';
          }
          break;

        case 'DayOfMonth':
        case 'DayOfYear':
        case 'WeekOfMonth':
        case 'WeekOfYear':
        case 'Hour':
        case 'Minute':
        case 'Month':
        case 'Year':
          return +part;

        default:
          return '!FIXME! ' + part + ' !FIXME!';
      }
    }
  }

  onDeleteClick() {
    this.deleteClick.emit();
  }

  deleteLeftOperator(index) {
    this.leftOperators.splice(index, 1);
    if (!this.inDeleteProcess) {
      this.changesEmitter.emit();
    }
  }

  deleteRightOperator(index) {
    this.rightOperators.splice(index, 1);
    if (!this.inDeleteProcess) {
      this.changesEmitter.emit();
    }
  }

  getReferenceKeyText(reference): string {
    return this.translate.instant('lang.globals.' + this.stringTransformation.toCamelCase(reference.key));
  }

  getAtomTypeText(name: string): string {
    return this.translate.instant('lang.cull.' + this.stringTransformation.toCamelCase(name));
  }

  getOptions() {
    if (this.rowIndex > 0) {
      if (this.leftOperators[0] === '&' || this.leftOperators[0] === '|') {
        return ['(', '!'];
      }
      return ['(', '&', '|', '!'];
    } else if (this.rowIndex === 0) {
      return ['(', '!'];
    } else {
      // error check?
      return [];
    }
  }

  changeLeftOperator($event: string, i: number) {
    if ($event) {
      if ($event === 'delete') {
        this.deleteLeftOperator(i);
      } else {
        this.leftOperators[i] = $event;
        this.changesEmitter.emit();
      }
    }
  }
}
